import { render, staticRenderFns } from "./TravRating.vue?vue&type=template&id=803c2072"
import script from "./TravRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./TravRating.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TravRating.vue?vue&type=style&index=0&id=803c2072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports